<template>
  <v-icon :class="getClass" :color="color" :size="size">
    {{ getMdiIcon }}
  </v-icon>
</template>

<script>
export default {
  name: 'AscIcon',

  props: {
    icon: {
      type: String,
      default: 'circle',
      validator: val =>
        [
          'chevronDown',
          'chevronUp',
          'circle',
          'square',
          'triangleUp',
          'triangleDown',
          'eyeOff',
          'eye',
          'info',
          'trash',
          'arrowExpand',
          'pencil',
          'wifiStrengthOff',
          'diamond',
          'triangle',
          'triangle-down',
        ].includes(val),
    },
    color: {
      type: String,
      default: '#000',
    },
    size: {
      type: Number,
      default: 12,
    },
  },

  computed: {
    getClass() {
      const classes = {
        chevronDown: 'asc-chevron-down',
        chevronUp: 'asc-chevron-up',
        circle: 'asc-circle',
        square: 'asc-square',
        triangle: 'asc-triangle-up',
        triangleUp: 'asc-triangle-up',
        triangleDown: 'asc-triangle-down',
        eyeOff: 'asc-eye-off',
        eye: 'asc-eye',
        info: 'asc-information',
        trash: 'asc-delete',
        arrowExpand: 'asc-arrow-expand',
        pencil: 'asc-pencil',
        wifiStrengthOff: 'asc-wifi-strength-off',
        diamond: 'asc-diamond',
        'triangle-down': 'asc-triangle-down',
      }

      return classes[this.icon]
    },

    getMdiIcon() {
      const icons = {
        chevronDown: 'mdi-chevron-down',
        chevronUp: 'mdi-chevron-up',
        circle: 'mdi-circle',
        square: 'mdi-square',
        triangle: 'mdi-triangle',
        triangleUp: 'mdi-triangle',
        triangleDown: 'mdi-triangle',
        eyeOff: 'mdi-eye-off',
        eye: 'mdi-eye',
        info: 'mdi-information',
        trash: 'mdi-delete',
        arrowExpand: 'mdi-arrow-expand',
        pencil: 'mdi-pencil',
        wifiStrengthOff: 'mdi-wifi-strength-off',
        diamond: 'mdi-cards-diamond',
        'triangle-down': 'mdi-triangle',
      }
      return icons[this.icon]
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-triangle-down {
  transform: rotate(180deg);
  display: inline-block;
  margin-top: 4px;
}

.asc-triangle-up {
  display: inline-block;
  margin-top: 4px;
}
</style>
